import React, { MouseEventHandler } from 'react';
import styled from 'styled-components';
import HoverablePreferences from './Preferences/HoverablePreferences';

const StyledUl = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  /* background-color: #333; */
`;

const StyledLi = styled.li`
  float: left;
  margin-bottom: 0px;
`;

const Dropbtn = styled.div`
  display: inline-block;
  color: white;
  text-align: center;
  /* padding: 14px 16px; */
  text-decoration: none;
`;

const DropDownContent = styled.div`
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  font-size: 10px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
`;

const DropDownLi = styled(StyledLi)`
  display: inline-block;
  &:hover {
    /* background-color: red; */
  }
  &:hover ${DropDownContent} {
    display: block;
  }
`;

const SubA = styled.a`
  color: black;
  padding: 6px 8px;
  text-decoration: none;
  display: block;
  text-align: left;
  &:hover {
    background-color: #f1f1f1;
    cursor: pointer;
  }
`;

export type AdminAction = {
  text: string;
  onClick: MouseEventHandler<HTMLAnchorElement>;
};

type Props = {
  actions: AdminAction[];
};

export const AdminButton: React.FC<Props> = ({ actions }) => {
  return (
    <StyledUl>
      <DropDownLi>
        <Dropbtn>
          <HoverablePreferences />
        </Dropbtn>
        <DropDownContent>
          {actions.map((action) => (
            <SubA key={action.text} onClick={action.onClick}>
              {action.text}
            </SubA>
          ))}
        </DropDownContent>
      </DropDownLi>
    </StyledUl>
  );
};
